module.exports = __webpack_public_path__ + "img/oximeter.139be743.png";